import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { useContext } from 'react';
import { TYPE_PAYMENT } from '../../../brands/default/constants';
import ThemeContext from '../../../providers/ThemeProvider';

const FormError = ({ errorText, formType }) => {
  const theme = useContext(ThemeContext);
  const componentClass = classNames('form-error', {
    'form-error--payment': formType === TYPE_PAYMENT,
  });

  return (
    <>
      <div className={componentClass}>
        <span>{errorText}</span>
      </div>
      <style jsx>{`
        .form-error {
          background-color: ${theme.colors.inputinvalidcolor};
          color: #ffffff;
          padding: 6px 12px;
        }
        .form-error--payment {
          background-color: ${theme.colors.errorboxbg};
          border: 1px solid ${theme.colors.errorboxborder};
          color: ${theme.colors.errorboxtext};
          padding: 6px 12px;
        }
      `}</style>
    </>
  );
};

FormError.propTypes = {
  errorText: PropTypes.string.isRequired,
  formType: PropTypes.string,
};

export default FormError;
